/* -------------------------------
   TRANSLATED WARNING MESSAGES
--------------------------------*/
function xvostFormatTemplate(template, values) {
  if (!template || !values) return template || '';
  let out = template;
  Object.keys(values).forEach((key) => {
    const token = `__${key}__`;
    out = out.split(token).join(String(values[key]));
  });
  return out;
}

function xvostSelectPluralForm(locale, count) {
  if (typeof Intl !== 'undefined' && Intl.PluralRules) {
    try {
      return new Intl.PluralRules(locale).select(count);
    } catch (e) {
      // fall through to default
    }
  }
  return count === 1 ? 'one' : 'other';
}

function xvostGetCreditsWarningMessage(data) {
  const { cartQtyAge, remainingCredits, totalCredits } = data;
  const canAdd = Math.max(remainingCredits, 0);
  const i18n = window.XVOST_SUBSCRIPTION_I18N || {};

  if (!i18n.warning || !i18n.warningCanAdd || !i18n.warningCannotAdd) {
    return '';
  }

  const canAddTemplate = canAdd > 0 ? i18n.warningCanAdd : i18n.warningCannotAdd;
  const canAddPart = xvostFormatTemplate(canAddTemplate, {
    COUNT: canAdd,
  });

  return xvostFormatTemplate(i18n.warning, {
    CART_QTY: cartQtyAge,
    TOTAL_CREDITS: totalCredits,
    CAN_ADD_PART: canAddPart,
    SUBSCRIPTIONS_URL: i18n.subscriptionsUrl || '/collections/subscriptions',
  });
}

/* ---------------------------------
   WARNING MESSAGE RENDERING
----------------------------------*/
function xvostShowCreditsWarning(container, data) {
  if (!container) return;
  const message = xvostGetCreditsWarningMessage(data);
  if (!message) return;
  container.innerHTML = message;
  container.style.display = 'block';
}

function xvostHideCreditsWarning(container) {
  if (!container) return;
  container.innerHTML = '';
  container.style.display = 'none';
}

/* ---------------------------------
   MAIN LOGIC
----------------------------------*/
(function () {

  function todayISO() {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function formatDateDDMMYYYY(iso) {
    if (!iso) return '';
    const [y, m, d] = iso.split('-');
    return `${d}.${m}.${y}`;
  }

  function daysUntilISO(iso) {
    if (!iso) return null;
    const parts = iso.split('-');
    if (parts.length !== 3) return null;
    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);
    if (!year || !month || !day) return null;
    const expiresUtc = Date.UTC(year, month - 1, day);
    const now = new Date();
    const nowUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.floor((expiresUtc - nowUtc) / 86400000);
  }

  // Recompute cart qty for this age from DOM (for cart:updated)
  function computeCartQtyForAgeFromDOM(normalizedAgeKey) {
    let total = 0;

    // Look for *any* element that has data-age, not only <tr class="cart-item">
    const rows = document.querySelectorAll('[data-age]');

    rows.forEach((row, index) => {
      const ageRaw = row.dataset.age || '';
      const ageNorm = ageRaw
        .replace(/[^\d\-–—]+/g, '')
        .replace(/[–—]/g, '-');

      // Try to detect quantity input in common ways
      const qtyInput =
        row.querySelector('input.quantity__input') ||
        row.querySelector('input[name^="updates["]') ||
        row.querySelector('input[type="number"]');

      const qty = qtyInput ? Number(qtyInput.value) || 0 : 0;

      if (ageNorm === normalizedAgeKey) {
        total += qty;
      }
    });

    return total;
  }

  function initSubscriptionPricing() {
    const rawSubs = window.XVOST_SUBSCRIPTION_CREDITS;
    const rawAgeLabel = window.XVOST_PRODUCT_AGE; // e.g. "6-12 лет"
    const sectionId = window.XVOST_SECTION_ID;
    const i18n = window.XVOST_SUBSCRIPTION_I18N || {};
    const localeFull = i18n.locale || window.XVOST_LOCALE || document.documentElement.lang || navigator.language || 'en';

    if (!rawSubs || !rawAgeLabel || !sectionId) return;

    // Normalize age key (from "6-12 лет" → "6-12")
    const normalizedAgeKey = rawAgeLabel
      .replace(/[^\d\-–—]+/g, '') // keep digits and dashes
      .replace(/[–—]/g, '-');     // normalize different dash types to "-"

    const subs = rawSubs; // already an object from Liquid

    // Make credits visible to other scripts (e.g. cart drawer)
    window.CREDITS = subs;

  if (!subs[normalizedAgeKey] || !Array.isArray(subs[normalizedAgeKey])) {
    return;
  }

  const summaryTemplates = i18n.summary || {};
  const cardTitlePrefix = i18n.cardTitlePrefix || '';
  const balanceLabel = i18n.balanceLabel || '';
  const expiresLabel = i18n.expiresLabel || '';
  const today = todayISO();

  const activeCerts = subs[normalizedAgeKey].filter((cert) => {
    if (!cert) return false;
    if (!cert.credits || cert.credits <= 0) return false;
    if (!cert.expires) return false;
    return cert.expires >= today;
  });


  if (!activeCerts.length) return;

  const totalCredits = activeCerts.reduce((sum, cert) => {
    const c = Number(cert.credits) || 0;
    return sum + c;
  }, 0);


  // Initial cart quantity for this age group (from Liquid, fallback to DOM)
  let cartQtyForAge = Number(window.XVOST_CART_AGE_QTY || 0);
  if (!cartQtyForAge) {
    cartQtyForAge = computeCartQtyForAgeFromDOM(normalizedAgeKey);
  }

  const remainingCredits = totalCredits - cartQtyForAge;


  // Price container on event-product template
  const priceContainer = document.querySelector(`#price-${sectionId}`);
  if (!priceContainer) {
    return;
  }


  // Strike-through original price properly
  priceContainer.querySelectorAll('.price-item').forEach((el) => {
    el.style.textDecoration = 'line-through';
    el.style.opacity = '0.6';
  });

  // Ensure we have a sibling container for our subscription UI
  let extra = priceContainer.nextElementSibling;
  if (!extra || !extra.dataset || extra.dataset.subscriptionPricing !== 'true') {
    extra = document.createElement('div');
    extra.dataset.subscriptionPricing = 'true';
    priceContainer.parentNode.insertBefore(extra, priceContainer.nextSibling);
  }

  const certCount = activeCerts.length;
  let summaryText = '';
  const pluralForm = xvostSelectPluralForm(localeFull, certCount);
  const summaryTemplate = summaryTemplates[pluralForm] || summaryTemplates.other || '';
  if (summaryTemplate) {
    summaryText = xvostFormatTemplate(summaryTemplate, {
      COUNT: certCount,
      AGE: rawAgeLabel,
    });
  }

  const cardTitle = cardTitlePrefix
    ? `${cardTitlePrefix} «${rawAgeLabel}»`
    : rawAgeLabel;

  // Build HTML
  let html = '';

  // Zero price using existing price classes
  html += `
    <div class="price price--large">
      <span class="price-item price-item--regular">€0</span>
    </div>
  `;

  // Summary line (you have N subscriptions…)
  if (summaryText) {
    html += `
      <p class="margin-bottom-1-5">
        ${summaryText}
      </p>
    `;
  }

  // Certificates list in cards
  let cardsHtml = '';

  const balanceLabelText = balanceLabel ? `${balanceLabel} ` : '';
  const expiresLabelText = expiresLabel ? `${expiresLabel} ` : '';

  activeCerts.forEach((cert) => {
    const credits = cert.credits;
    const daysLeft = daysUntilISO(cert.expires);
    const showExpiresSoon =
      typeof daysLeft === 'number' && daysLeft >= 0 && daysLeft <= 30 && i18n.expiresSoon;
    const showLowCredits = Number(credits) < 3 && i18n.lowCreditsHtml;
    const expiresFormatted = formatDateDDMMYYYY(cert.expires);
    console.log('[SUBS DEBUG] days until expiry', {
      expires: cert.expires,
      daysLeft,
      credits,
    });

    cardsHtml += `
      <div class="certificate-card-wrapper">
        <h3 class="margin-0">${cardTitle}</h3>
        <p class="caption-large margin-0">${balanceLabelText}${credits}</p>
        <p class="caption-large margin-0">${expiresLabelText}${expiresFormatted}</p>
        ${showExpiresSoon ? `<p class="caption-large margin-0">${i18n.expiresSoon}</p>` : ''}
        ${showLowCredits ? `<p class="caption-large margin-0">${i18n.lowCreditsHtml}</p>` : ''}
      </div>
    `;
  });

  // Warning container (initially empty, only filled when blocked)
  html += `
    <div class="flex vertical gap-1-5">
      ${cardsHtml}
    </div>
    <div class="xvost-age-credits-warning"
         style="margin-top:0.75rem;font-size:0.9rem;line-height:1.4;border-left:3px solid #e67b73;padding-left:0.75rem;display:none;"></div>
  `;

  extra.innerHTML = html;

  const warningContainer = extra.querySelector('.xvost-age-credits-warning');

  // Attach check to the Add to cart button click
  const submitButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);

  // Hide warning when user adjusts quantity on product page back within limit
  const pageQtyInput = document.querySelector(`#Quantity-${sectionId}`);
  if (pageQtyInput) {
    pageQtyInput.addEventListener('input', function () {
      const pageQty = Number(pageQtyInput.value) || 1;
      const desiredTotalForAge = cartQtyForAge + pageQty;

      if (desiredTotalForAge <= totalCredits) {
        xvostHideCreditsWarning(warningContainer);
      }
    });
  }

  if (submitButton) {
    submitButton.addEventListener('click', function (event) {
      // We trust cartQtyForAge as our current known value:
      // - initially from Liquid (XVOST_CART_AGE_QTY)
      // - then incremented locally after successful adds

      // Current quantity selected on the product page
      const qtyInput = document.querySelector(`#Quantity-${sectionId}`);
      const pageQty = qtyInput ? Number(qtyInput.value) || 1 : 1;

      const desiredTotalForAge = cartQtyForAge + pageQty;
      const remainingBeforeAdd = totalCredits - cartQtyForAge;

      if (desiredTotalForAge > totalCredits) {
        event.preventDefault();
        event.stopImmediatePropagation();

        xvostShowCreditsWarning(warningContainer, {
          cartQtyAge: cartQtyForAge,
          remainingCredits: remainingBeforeAdd,
          totalCredits,
        });

        return;
      }

      // Quantity is valid → hide the warning
      xvostHideCreditsWarning(warningContainer);

      // If we are here, the add is allowed → optimistically update our local counter
      cartQtyForAge = desiredTotalForAge;
    });
  }

  // Log when the cart is updated (remove item / change quantity)
  document.addEventListener('cart:updated', () => {
    const updatedCartQty = computeCartQtyForAgeFromDOM(normalizedAgeKey);
    cartQtyForAge = updatedCartQty;
  });
  }

  function waitForI18n(tries) {
    if (window.XVOST_SUBSCRIPTION_I18N) {
      initSubscriptionPricing();
      return;
    }

    if (tries >= 40) {
      return;
    }

    setTimeout(() => waitForI18n(tries + 1), 50);
  }

  waitForI18n(0);
})();
